import React, { useState } from "react";
import { RiMenuFill, RiCloseCircleFill, RiLoginBoxLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import sitedata from "../sitedetails.json";
import { useDispatch, useSelector } from "react-redux";
import { logoutAction } from "../redux/actions/userAction";

const Sidebar = (isAdmin) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const isSidebarClose = true;
  const [visible, setVisible] = useState(false);
  const role = isAdmin.isAdmin
  const { isAuthenticated } = useSelector((state) => state.user);
  // const isAuthenticated = false;
 const dispatch = useDispatch()
  const logoutHandler = () => {
    dispatch(logoutAction())
  }
  return (
    <>
      {/* main div  */}
      <div className="fixed z-10 text-white font-outfit h-full">
        {isSidebarOpen && (
          <button
            className=" fixed bg-black px-2 rounded-full py-2 top-8 left-8"
            onClick={() => {
              setSidebarOpen(!setSidebarOpen);
              setVisible(true);
            }}
          >
            {" "}
            <RiMenuFill />{" "}
          </button>
        )}

        {visible && (
          // main
          <div className="h-[700px] sm:h-full flex flex-col pb-10 justify-between w-[300px] pt-10 text-center bg-brand_nero">
            {/* top elements */}
            <div>
              {isSidebarClose && (
                <button
                  className=" rounded-sm fixed top-8 left-8 "
                  onClick={() => {
                    setVisible(false);
                    setSidebarOpen(true);
                  }}
                >
                  {" "}
                  <RiCloseCircleFill />{" "}
                </button>
              )}

              <Link
                onClick={() => {
                  setVisible(false);
                  setSidebarOpen(true);
                }}
                to="/"
              >
                <h1 className="py-3 mt-6 mb-3 hover:text-brand_green ">
                  {sitedata.brand_name}
                </h1>{" "}
              </Link>
              <div className="bg-white h-[1px] w-[75%] mx-auto my-2"></div>
              {isAuthenticated ? <Link
                className=""
                onClick={() => {
                  setVisible(false);
                  setSidebarOpen(true);
                }}
                to="/mycourses"
              >
                <h1 className="py-3 my-4 hover:text-brand_green ">
                  My Courses
                </h1>{" "}
              </Link> : "" } 
              <Link
                onClick={() => {
                  setVisible(false);
                  setSidebarOpen(true);
                }}
                to="/courses"
              >
                <h1 className="py-3 my-4 hover:text-brand_green ">
                  Browse All Courses
                </h1>{" "}
              </Link>
              <Link
                onClick={() => {
                  setVisible(false);
                  setSidebarOpen(true);
                }}
                to="/blogs"
              >
                <h1 className="py-3 my-4 hover:text-brand_green ">Blogs</h1>{" "}
              </Link>
              <Link
                onClick={() => {
                  setVisible(false);
                  setSidebarOpen(true);
                }}
                to="/contact"
              >
                <h1 className="py-3 my-4 hover:text-brand_green ">
                  About
                </h1>{" "}
              </Link>
            </div>
            {/* bottom elements  */}
            <div>
              {!isAuthenticated && (
                <div className="flex justify-center gap-6">
                  <Link
                    onClick={() => {
                      setVisible(false);
                      setSidebarOpen(true);
                    }}
                    to="/signup"
                  >
                    <h1 className="hover:text-brand_green">Sign Up</h1>{" "}
                  </Link>
                  <Link
                    onClick={() => {
                      setVisible(false);
                      setSidebarOpen(true);
                    }}
                    to="/login"
                  >
                    <h1 className="hover:text-brand_green">Sign in</h1>{" "}
                  </Link>
                </div>
              )}
              {isAuthenticated && (
                <div className="flex justify-center gap-6">

                  { role && role==='admin' ?  <Link
                    onClick={() => {
                      setVisible(false);
                      setSidebarOpen(true);
                    }}
                    to="/admin/dashboard"
                  >
                    <h1 className="text-brand_yellow">Dashboard</h1>
                  </Link> : <Link onClick={() => {
                      setVisible(false);
                      setSidebarOpen(true);
                    }} className="text-brand_yellow" to='/profile'>Profile</Link>}
                  

                  <button onClick={() =>{logoutHandler(); setVisible(false);
                      setSidebarOpen(true); }} className="flex items-center px-2">
                    Logout{" "}
                    <span className="px-2">
                      <RiLoginBoxLine />
                    </span>{" "}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;
